import styled from '@emotion/styled';

export const BeneficiaryAccountStepContent = styled.div``;
